import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import {FromDriveComponent} from "./fromDrive.component";

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [FromDriveComponent],
    exports: [FromDriveComponent]
})

export class FromDriveModule { }
